import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modules = require('@/project/store.js')

export default new Vuex.Store({
  state: {
    screenWidth: document.documentElement.clientWidth,
    screenHeight: document.documentElement.clientHeight
  },
  modules: modules.default
})
